// Sure, here's the content for the file `/amazon-clone/amazon-clone/src/pages/Customer.js`:

import React from 'react';

const Customer = () => {
    return (
        <div>
            <h1>Customer Page</h1>
            <p>Welcome to the customer section of the application.</p>
        </div>
    );
};

export default Customer;